import { Box } from '@mui/material';
import { PRODUCT_FIELDS } from '../../utils/dashboardUtils';
import DashboardMultiSelect, { MENU_PAPER_LIGHT } from './DashboardMultiSelect';

const ModuleSlicer = ({ type, value, onChange, departments, colors }) => {
  const label = type === 'product' ? 'Product' : 'Department';
  const options = type === 'product'
    ? PRODUCT_FIELDS.map((p) => ({ value: p, label: p }))
    : (departments || []).map((d) => ({ value: d, label: d }));

  return (
    <Box display="flex" justifyContent="flex-end" mb={0.75}>
      <DashboardMultiSelect
        label={label}
        value={value}
        options={options}
        onChange={onChange}
        minWidth={type === 'department' ? 180 : 110}
        sx={{
          bgcolor: 'rgba(255,255,255,0.14)',
          borderRadius: 1,
          color: colors.grey[100],
          height: 36,
          '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.3)' },
          '.MuiSvgIcon-root': { color: colors.grey[200] },
          '.MuiInputLabel-root': { color: colors.grey[300] },
        }}
        menuProps={MENU_PAPER_LIGHT}
      />
    </Box>
  );
};

export default ModuleSlicer;
